import { FC, useMemo } from 'react';

import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import styles from './DescriptionBox.module.scss';
import { useHighlightPopupService } from './HighlighPopupService';
import { usePopupContext } from './usePopupContact';

export const PopupDescriptionContainer: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  // the popup is positioned absolutely on top of the actual side nav item
  // so we need to use javascript to position this component based on
  // side nav rect.
  const { currentPopupRect } = useHighlightPopupService();

  const leftPosition = useMemo(() => {
    const leftCoord = currentPopupRect?.left || 0;
    const rectWidth = currentPopupRect?.width || 0;

    return leftCoord + rectWidth + 30;
  }, [currentPopupRect?.left, currentPopupRect?.width]);

  const topPosition = useMemo(() => {
    const topCoord = currentPopupRect?.top || 0;

    return topCoord - 20;
  }, [currentPopupRect?.top]);

  return (
    <div
      className={styles['description-container']}
      style={{
        top: `${topPosition}px`,
        left: `${leftPosition}px`,
      }}
    >
      {children}
    </div>
  );
};

export const PopupDescriptionContent: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { closePopup } = usePopupContext();

  return (
    <div className={styles['description-content']}>
      <button
        onClick={(event) => {
          event.stopPropagation();
          closePopup && closePopup();
        }}
        className={styles['close-button']}
      >
        <FontAwesomeIcon icon={faTimes} />
      </button>
      {children}
    </div>
  );
};

export const PopupDescriptionTopSection: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <div className={styles['top-section']}>{children}</div>;
};

export const PopupDescriptionTopSectionIcon: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <span className={styles['top-section-icon']}>{children}</span>;
};

export const PopupDescriptionTopSectionText: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <span className={styles['top-section-text']}>{children}</span>;
};

export const PopupDescriptionTitle: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <h3 className={styles['description-title']}>{children}</h3>;
};

export const PopupDescriptionText: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <p className={styles['description-text']}>{children}</p>;
};

export const PopupDescriptionButtonContainer: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <h3 className={styles['btns-container']}>{children}</h3>;
};
